import * as React from 'react'

import Dialog, { DialogProps } from '@material-ui/core/Dialog'

import { ReactComponent }       from '../../types'
import { OpenerComponentProps } from '../molecules/SelectDialog'

export interface InjectedAsDialogProps {
  close: () => void
}

interface WrappedComponentProps {
  children: (openerProps: OpenerComponentProps) => JSX.Element
  dialogProps?: DialogProps
}

interface State {
  isOpen: boolean
}

function asDialog <P> (Component: ReactComponent<P & InjectedAsDialogProps>) {
  return class extends React.Component<P & WrappedComponentProps, State> {
    public state = {
      isOpen: false,
    }

    public render () {
      const {
        children,
        dialogProps,
        ...rest
      } = this.props as any

      const { isOpen } = this.state

      return (
        <>
          {children({ open: this.toggleOpen })}
          <Dialog
            onClose={this.toggleOpen}
            open={isOpen}
            {...dialogProps}
          >
            <Component
              close={this.toggleOpen}
              {...rest}
            />
          </Dialog>
        </>
      )
    }

    private toggleOpen = () => {
      this.setState(
        state => ({
          isOpen: !state.isOpen,
        }),
      )
    }
  }
}

export default asDialog



// WEBPACK FOOTER //
// ./src/components/hocs/asDialog.tsx